/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CloseBtn, DashedLine, DownArr, LeftArr, MapDis, MapTime, MinusSvg, PlusSvg, BillDesk, SelectRadio, StArr, Stations, UnSelectRadio, Journey, RoundJourney } from "../../../components/common/svg/AllSvg";
import { useTranslation } from "react-i18next";
import { getMapData } from "../../../shared/utils/mapUtils";
import moment from "moment";
import SecondaryBtn from "../../../components/common/form/SecondaryBtn";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { Helmet } from "react-helmet";
import Canonical from "../../../components/common/layout/Canonical";

const BookTicket = () => {
    const [routeData, setRouteData] = useState<any>(null)
    const [roundTrip, setRoundTrip] = useState<boolean>(false)
    const [count, setCount] = useState<number>(1)
    const [fare, setFare] = useState<any>(0)
    const [select, setSelect] = useState<boolean>(true)
    const [submit, setSubmit] = useState<boolean>(false)
    const [pay, setPay] = useState<boolean>(false)
    const [fail, setFail] = useState<boolean>(false)
    const [maxFail, setMaxFail] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [tripFocus, setTripFocus] = useState<boolean>(false)
    const { t } = useTranslation('common');
    const navigate = useNavigate();
    const params = useParams();
    const [lang, setLang] = useState<string>((params?.lang === "en" || params?.lang === "hi" || params?.lang === "mr") ? params?.lang : "en")
    const location = useLocation();
    const [journeyPlan, setJourneyPlan] = useState<any>({
        from: '',
        fromName: '',
        to: '',
        toName: '',
        date: moment(new Date()).format('YYYY-MM-DDTHH:mm'),
        advanced: 'least-distance',
        fromType: "",
        toType: "",
        journey: "one_way"
    })

    useEffect(() => {
        const search = new URLSearchParams(location.search);
        if (!!search.get('from') && !!search.get('fromName') && !!search.get('to') && !!search.get('toName') && !!search.get('fromType') && !!search.get('toType') && !!search?.get('date')) {
            let obj: any = {
                from: search.get('from'),
                fromName: search.get('fromName'),
                to: search.get('to'),
                toName: search.get('toName'),
                // date: search.get('date'),
                date: moment(new Date()).format('YYYY-MM-DDTHH:mm'),
                advanced: 'least-distance',
                fromType: search.get('fromType'),
                toType: search.get('toType'),
                journey: search.get('journey')
            };

            setJourneyPlan(obj)
            !!lang && getRoute(obj, (lang))
            setRoundTrip(search?.get('journey') === "one_way" ? false : true)
        }
    }, [location, params, lang])

    const getRoute = async (obj: any, language: any) => {
        const data = await getMapData(obj, language)
        if (data) {
            setRouteData(data)
        }
    }

    useEffect(() => {
        const footerEl: any = document.getElementById('footer');
        if (!!footerEl) footerEl.style.display = 'none'
    }, [])

    const getFare = async () => {
        try {
            setLoading(true)
            let obj: any = {
                // moment(journeyPlan?.date).format('YYYY-MM-DD')
                "journey": {
                    "from_station": journeyPlan?.from,
                    "to_station": journeyPlan?.to,
                    "journey_date": moment(new Date()).format('YYYY-MM-DD')
                },
                "booking_type": !roundTrip ? "one_way" : "round_way",
                "no_of_tickets": count
            }
            const res: any = await useAxios.post(`${url.get_ticket_price}`, obj);

            if (res && res.status === 200) {
                setFare(res?.data?.results)
                setLoading(false)
            }
        } catch (error) {
            setFail(true)
            console.error("error while save trip", error);
        }
    }

    useEffect(() => {
        (!!lang && !!journeyPlan?.from && !!journeyPlan?.to && !!journeyPlan?.date) && getFare();
    }, [lang, journeyPlan, count, roundTrip])

    const getBookTicket = async () => {
        try {
            setSubmit(true)
            // moment(journeyPlan?.date).format('YYYY-MM-DD')
            let obj: any = {
                "journey": {
                    "from_station": journeyPlan?.from,
                    "to_station": journeyPlan?.to,
                    "journey_date": moment(new Date()).format('YYYY-MM-DD')
                },
                "booking_type": !roundTrip ? "one_way" : "round_way",
                "no_of_tickets": count,
                "requested_from": "web"
            }
            const res: any = await useAxios.post(`${url.book_ticket}`, obj);

            if (res && res.status === 201) {
                window.location.href = (url?.baseUrl + url?.payment_page + res?.data?.data?.payment_instance)
                setSubmit(false)
            }
        } catch (error: any) {
            setSubmit(false)
            if (error && error?.response?.status === 400) {
                if (error?.response?.data?.errors?.toString()?.includes("Maximum 20 tickets")) {
                    setMaxFail(true)
                } else {
                    setFail(true)
                }
            }
            console.error("error while book ticket", error);
        }
    }

    useEffect(() => {
        if (fail || maxFail) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [fail, maxFail]);

    document.onkeydown = function (evt: any) {
        if (evt.keyCode === 27) {
            setFail(false)
            setMaxFail(false)
        }
    };

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.book_ticket.title")}</title>
                <meta name="description" content={t("seo_friendly.book_ticket.desc")} />
            </Helmet>
            {/* fail */}
            {fail &&
                <div className="fixed inset-0 z-[34] overflow-y-hidden top-0 ">
                    <div
                        className="fixed inset-0 w-full h-full bg-[rgba(216,216,216,0.60)] backdrop-blur-[15px]" onClick={() => setFail(false)}
                    ></div>
                    <div className="flex justify-center items-center min-h-screen">
                        <div className="m-[15px] md:mx-auto relative bg-white dark:bg-bgDarkDull rounded-[20px] flex flex-col lg:flex-row w-[600px] h-full shadow-[0px_14.134px_69.101px_-3.141px_rgba(24,39,75,0.14),0px_6.282px_21.987px_-4.711px_rgba(24,39,75,0.12)]">
                            <button aria-label={t("aria_label.close")} title={t("aria_label.close")} className="absolute top-[8px] right-[8px] mm:top-[15px] mm:right-[15px] rounded-full focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] min-w-[23px] h-[23px] flex items-center justify-center bg-[#e4e4e4] dark:bg-[#4c4e5e5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => setFail(false)}>
                                <CloseBtn />
                            </button>
                            <div className="flex flex-col w-full px-[30px] py-[60px] items-center justify-center">
                                <div className="min-w-[105px] h-[105px] flex items-center justify-center rounded-full bg-secDarkRed">
                                    <img src={require("../../../assets/images/service-fail.gif")} alt="service-fail" className="w-[81px] h-[81px]" />
                                </div>
                                <h3 className="text-primaryText dark:text-white text-2xl font-bold mt-[20px]">{t("passenger.map.book_ticket_sec.fail.title")}</h3>
                                <h6 className="text-blackDark dark:text-textBlackDark font-semibold mt-[10px] text-center">{t("passenger.map.book_ticket_sec.fail.desc")}</h6>
                                <h6 className="text-blackDark dark:text-textBlackDark font-medium mt-[2px] text-center">{t("passenger.map.book_ticket_sec.fail.desc1")}</h6>
                                <SecondaryBtn onClick={() => navigate(-1)} title={t("lang.go_back")} css="!rounded-[10px] px-[40px] font-extrabold uppercase !h-[35px] mt-[30px]" />
                            </div>
                        </div>
                    </div>
                </div>
            }

            {maxFail &&
                <div className="fixed inset-0 z-[34] overflow-y-hidden top-0 ">
                    <div
                        className="fixed inset-0 w-full h-full bg-[rgba(216,216,216,0.60)] backdrop-blur-[15px]" onClick={() => setMaxFail(false)}
                    ></div>
                    <div className="flex justify-center items-center min-h-screen">
                        <div className="m-[15px] md:mx-auto relative bg-white dark:bg-bgDarkDull rounded-[20px] flex flex-col lg:flex-row w-[600px] h-full shadow-[0px_14.134px_69.101px_-3.141px_rgba(24,39,75,0.14),0px_6.282px_21.987px_-4.711px_rgba(24,39,75,0.12)]">
                            <button aria-label={t("aria_label.close")} title={t("aria_label.close")} className="absolute top-[8px] right-[8px] mm:top-[15px] mm:right-[15px] rounded-full focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] min-w-[23px] h-[23px] flex items-center justify-center bg-[#e4e4e4] dark:bg-[#4c4e5e5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => setMaxFail(false)}>
                                <CloseBtn />
                            </button>
                            <div className="flex flex-col w-full px-[30px] py-[60px] items-center justify-center">
                                <div className="min-w-[105px] h-[105px] flex items-center justify-center rounded-full bg-secDarkRed">
                                    <img src={require("../../../assets/images/service-fail.gif")} alt="service-fail" className="w-[81px] h-[81px]" />
                                </div>
                                <h3 className="text-primaryText dark:text-white text-2xl font-bold mt-[20px]">{t("passenger.map.book_limit.line1")}</h3>
                                <h6 className="text-blackDark dark:text-textBlackDark font-medium mt-[10px] text-center max-w-[390px]">{t("passenger.map.book_limit.line2")}</h6>
                                <SecondaryBtn onClick={() => navigate(-1)} title={t("lang.go_back")} css="!rounded-[10px] px-[40px] font-extrabold uppercase !h-[35px] mt-[30px]" />
                            </div>
                        </div>
                    </div>
                </div>
            }

            <div className="bg-[#EFEFEF] dark:bg-bgDark w-full h-full min-h-screen py-[15px]">
                <div className="container">
                    <div className="h-[80px] flex items-center gap-[8px] w-full bg-white dark:bg-bgDarkDull rounded-[10px] px-[25px] xlx:px-[50px]">
                        <button aria-label={t("aria_label.back")} title={t("aria_label.back")} className="flex items-center justify-center w-[25px] h-[25px] rounded-full border border-transparent hover:border hover:border-[#ddd] focus:border focus:border-[#ddd] dark:focus:border-[#ffffff5e] dark:hover:border-[#ffffff5e] dark:bg-bgDarkDull bg-white" type="button" onClick={() => navigate(-1)}>
                            <LeftArr />
                        </button>

                        <h4 className="text-blackDark dark:text-textBlackDark font-bold">{t("passenger.map.book_ticket")}</h4>
                    </div>

                    <div className="py-[35px] flex justify-center w-full gap-[20px] xlx:gap-[23px] items-center mms:items-start mms:flex-row flex-col">
                        <div className="w-full xlsm:w-[450px] flex flex-col gap-[20px] xlx:gap-[27px]">
                            <div className="w-full bg-white dark:bg-bgDarkDull rounded-[20px] py-[17px] px-[20px] xlx:px-[24px] h-full transition-all duration-100">
                                <h6 className="text-blackDull dark:text-textBlackDull font-extrabold w-full border-b border-[#00000036] dark:border-blackDull uppercase pb-[8px]">{t("passenger.map.book_ticket_sec.title")}</h6>

                                <div className="flex items-center gap-[12px] w-full border-b border-[#00000036] dark:border-blackDull py-[16px] justify-between">
                                    <div className="flex flex-col gap-[8px]">
                                        <p className="text-[#3D3D3D] dark:text-textBlackDull uppercase font-semibold">{t("passenger.lost_found.report_form.from_station")}</p>
                                        <h3 className="uppercase text-[1.5rem] font-extrabold text-[#5E4796] dark:text-[#a98eed]">{journeyPlan?.from}</h3>
                                        <p className="text-[#3D3D3D] dark:text-textBlackDull font-medium text-opacity-[0.8]">{journeyPlan?.fromName}</p>
                                    </div>

                                    <StArr />

                                    <div className="flex flex-col gap-[8px]">
                                        <p className="text-[#3D3D3D] dark:text-textBlackDull uppercase font-semibold">{t("passenger.lost_found.report_form.to_station")}</p>
                                        <h3 className="uppercase text-[1.5rem] font-extrabold text-[#5E4796] dark:text-[#a98eed]">{journeyPlan?.to}</h3>
                                        <p className="text-[#3D3D3D] dark:text-textBlackDull font-medium text-opacity-[0.8]">{journeyPlan?.toName}</p>
                                    </div>
                                </div>

                                <div className="pt-[16px] w-full flex items-center gap-[10px] xlx:gap-[15px] justify-between flex-wrap">
                                    <div className="flex flex-col gap-[2px]">
                                        <p className="text-[#3D3D3D] dark:text-textBlackDull uppercase font-semibold">{t("passenger.map.book_ticket_sec.date")}</p>
                                        <h5 className="font-bold text-[#5E4796] dark:text-[#a98eed]">{moment(journeyPlan?.date).format('DD MMM YYYY, hh:mm A')}</h5>
                                    </div>

                                    <div className={`${pay ? "flex flex-col" : "hidden"} justify-end xxs:w-auto w-full`}>
                                        <h3 className="text-[1.5rem] font-extrabold text-primaryText dark:text-white text-right">₹ {fare}</h3>
                                        <p className="text-blackDull dark:text-textBlackDull text-opacity-[0.6] font-semibold text-right">{t("passenger.map.book_ticket_sec.tax")}</p>
                                    </div>
                                </div>

                                <div className={`${!pay ? "flex flex-col" : "hidden"}`}>
                                    <div className="w-full relative mt-[16px]">
                                        <div className="min-w-[25px] h-[25px] rounded-full bg-[#EFEFEF] dark:bg-bgDark absolute top-[-11.5px] left-[-36.5px] opacity-[0.6]"></div>
                                        <div className="w-full overflow-hidden min-h-[2px]">
                                            <DashedLine />
                                        </div>
                                        <div className="min-w-[25px] h-[25px] rounded-full bg-[#EFEFEF] dark:bg-bgDark absolute top-[-11.5px] right-[-36.5px] opacity-[0.6]"></div>
                                    </div>

                                    <div className="rounded-[12px] border border-[#FCDFDF] dark:border-[#5b4f4f] w-full bg-white dark:bg-bgDarkDull flex flex-col gap-[2px] mt-[15px] flex-wrap py-[10px] px-[12px] mb-[10px]">
                                        <p className="text-secDarkRed font-medium">{t("passenger.map.book_ticket_sec.validity")}</p>
                                        <p className="text-secDarkRed font-medium">{t("passenger.map.book_ticket_sec.validity2")}</p>
                                        <p className="text-secDarkRed font-medium">{t("passenger.map.book_ticket_sec.validity1")}</p>
                                    </div>


                                    <div className="rounded-[12px] border border-[#E5DFFC] dark:border-blackDark w-full bg-white dark:bg-bgDarkDull py-[20px] px-[25px] flex items-center gap-[25px] justify-between flex-wrap">
                                        <div className="flex items-center gap-[8px]">
                                            <MapDis />
                                            <div className="flex flex-col">
                                                <p className="text-blackDull dark:text-textBlackDull font-medium">{t("passenger.home.fare.detail.distance")}</p>
                                                <h5 className="text-primaryText dark:text-white font-bold">{!!routeData?.distance ? parseFloat(routeData?.distance?.replace(" km", "")).toFixed(2) : "0"} {t("passenger.home.fare.detail.km")}</h5>
                                            </div>
                                        </div>

                                        {/* <div className="flex items-center gap-[8px]">
                                            <MapTime />
                                            <div className="flex flex-col">
                                                <p className="text-blackDull dark:text-textBlackDull font-medium">{t("passenger.home.fare.detail.est_time")}</p>
                                                <h6 className="text-primaryText dark:text-white font-bold">{(Math.round(moment.duration(routeData?.total_time).asMinutes())) || 0} {t("passenger.home.fare.detail.min")}</h6>
                                            </div>
                                        </div> */}

                                        <div className="flex items-center gap-[8px]">
                                            <Stations />
                                            <div className="flex flex-col">
                                                <p className="text-blackDull dark:text-textBlackDull font-medium">{t("passenger.map.book_ticket_sec.sts")}</p>
                                                <h6 className="text-primaryText dark:text-white font-bold">{routeData?.stations}</h6>
                                            </div>
                                        </div>

                                        <div className="flex items-center gap-[10px]">
                                            {!roundTrip ? <Journey /> : <RoundJourney />}
                                            <div className="flex flex-col">
                                                <p className="text-blackDull dark:text-textBlackDull font-medium">{t("passenger.map.book_ticket_sec.journey")}</p>
                                                <h6 className="text-primaryText dark:text-white font-bold">{!roundTrip ? t("passenger.home.banner.trip_planner.one_way") : t("passenger.home.banner.trip_planner.round_trip")}</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col gap-[20px] py-[25px] w-full">
                                        {/* <div className="flex items-center justify-between w-full gap-[15px] flex-wrap">
                                            <div className="flex flex-col gap-[2px]">
                                                <h5 className="text-blackDark dark:text-textBlackDark font-bold">{t("passenger.home.banner.trip_planner.round_trip")}</h5>
                                                <p className="text-blackDull dark:text-textBlackDull font-medium">{t("passenger.map.book_ticket_sec.round_trip_desc")}</p>
                                            </div>

                                            {loading ? <div className="min-w-[36px] h-[20px] bg-gray-200 rounded-full dark:bg-gray-700"></div> : <label className="relative inline-flex items-center cursor-pointer">
                                                <input type="checkbox" checked={roundTrip} className="sr-only peer" onChange={() => setRoundTrip(!roundTrip)} onFocus={() => setTripFocus(true)} onBlur={() => setTripFocus(false)} />
                                                <div className={`w-[36px] h-[20px] bg-[#D9D9D966] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-[#4e566e66] after:border after:rounded-full after:h-[16px] after:w-[16px] after:transition-all after:peer-checked:bg-primary ${tripFocus && "focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] rounded-full"}`} ></div>
                                            </label>}
                                        </div> */}

                                        <div className="flex items-center justify-between w-full gap-[15px] flex-wrap">
                                            <div className="flex flex-col gap-[2px]">
                                                <h5 className="text-blackDark dark:text-textBlackDark font-bold">{t("passenger.map.book_ticket_sec.passengers")}</h5>
                                                <p className="text-blackDull dark:text-textBlackDull font-medium">{t("passenger.map.book_ticket_sec.passengers_desc")}</p>
                                            </div>

                                            <div className="flex items-center gap-[10px]">
                                                {loading ? <div className="h-[23px] bg-gray-200 rounded-full dark:bg-gray-700 min-w-[23px]"></div> : <button type="button" aria-label={t("aria_label.dec")} title={t("aria_label.dec")} onClick={() => count > 1 && setCount(count - 1)} className="focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] rounded-full"><MinusSvg /></button>}
                                                <h5 className="text-blackDark dark:text-textBlackDark font-bold">{count}</h5>
                                                {loading ? <div className="h-[23px] bg-gray-200 rounded-full dark:bg-gray-700 min-w-[23px]"></div> : <button type="button" aria-label={t("aria_label.inc")} title={t("aria_label.inc")} onClick={() => count < 6 && setCount(count + 1)} className="focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] rounded-full"><PlusSvg /></button>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full overflow-hidden min-h-[2px] relative">
                                        <DashedLine />
                                    </div>

                                    <div className="flex items-center justify-between w-full gap-[15px] mt-[20px] mb-[15px] flex-wrap">
                                        <div className="flex flex-col">
                                            {loading ? <div className="h-[33px] bg-gray-200 rounded-[8px] dark:bg-gray-700 w-[90px]"></div> : <h3 className="text-[1.5rem] font-extrabold text-primaryText dark:text-white">₹ {fare}</h3>}
                                            <p className="text-blackDull dark:text-textBlackDull text-opacity-[0.6] font-semibold">{t("passenger.map.book_ticket_sec.tax")}</p>
                                        </div>

                                        <SecondaryBtn onClick={() => setPay(true)} title={t("passenger.map.book_ticket_sec.pay")} css="!rounded-[10px] px-[20px] font-extrabold uppercase !h-[35px]" disabled={(((+parseInt(fare)?.toFixed()) === 0) || loading) ? true : false} />
                                    </div>
                                </div>
                            </div>

                            <div className="w-full bg-white dark:bg-bgDarkDull rounded-[20px] px-[20px] xlx:px-[24px] h-full transition-all duration-100">
                                <div className="flex items-center gap-[15px] justify-between w-full h-[45px] xlx:h-[55px]">
                                    <h6 className="text-blackDull dark:text-textBlackDull font-extrabold w-full uppercase">{t("passenger.map.book_ticket_sec.select")}</h6>
                                    <DownArr />
                                </div>

                                <div className={`rounded-[12px] border border-[#E5DFFC] dark:border-blackDark w-full bg-white dark:bg-bgDarkDull p-[15px] xlx:p-[20px] items-center justify-between gap-[15px] ${pay ? "flex" : "hidden"}`}>
                                    <div className="flex items-center gap-[8px]">
                                        <div className="rounded-full min-w-[30px] xlx:min-w-[35px] h-[30px] xlx:h-[35px] flex items-center justify-center bg-[#F4F4F4]">
                                            <BillDesk />
                                        </div>
                                        <div className="flex flex-col max-w-[120px] xs:max-w-max">
                                            <h6 className="text-blackDull dark:text-textBlackDull font-extrabold">{t("passenger.map.book_ticket_sec.bill_desk")}</h6>
                                            <p className="text-primary font-semibold max-w-[120px]xs:max-w-max">{t("passenger.map.book_ticket_sec.bill_desk_desc")}</p>
                                        </div>
                                    </div>

                                    <button type="button" className="focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] rounded-full">{select ? <SelectRadio /> : <UnSelectRadio />}</button>
                                </div>

                                <div className={`${pay ? "flex" : "hidden"} items-end justify-end w-full mt-[12px] mb-[12px] xlx:mb-[17px]`}>
                                    <SecondaryBtn title={t("passenger.map.book_ticket_sec.pay_now")} css="!rounded-[10px] px-[30px] font-extrabold uppercase !h-[35px]" onClick={getBookTicket} disabled={submit} />
                                </div>
                            </div>
                        </div>

                        <div className="rounded-[20px] border border-[#E4E4E7] dark:border-[#454545] bg-white dark:bg-bgDarkDull shadow-[0px_42.444px_61.308px_0px_rgba(0,0,0,0.08)] p-[9px] w-full xs:w-[290px] xlx:w-[300px] h-fit">
                            <div className="h-[240px] xlx:h-[258px] rounded-[14px] bg-[#F0F4F9] dark:bg-bgDark w-full">
                                <img src={require("../../../assets/images/book-ticket.png")} alt="fare-card" className="rounded-[14px] h-[240px] xlx:h-[258px] w-full" />
                            </div>

                            <div className="pt-[14px] pb-[11px] px-[12px] ">
                                <h4 className="text-primaryText dark:text-white font-bold ">{t("passenger.home.fare.card.title")}</h4>
                                <p className="text-blackDull dark:text-textBlackDull font-semibold mt-[4px]">{t("passenger.home.fare.card.desc")}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BookTicket;